module.exports = __webpack_public_path__ + "img/1.434914ab.jpg";